<template>
  <q-layout view="hHh lpR fFf">
    <q-header v-if="initialized">
      <toolbar />
    </q-header>
    <q-page-container>
      <router-view v-if="initialized" class="app-content-wrap" />
    </q-page-container>
    <cookie-banner v-if="initialized" />
  </q-layout>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue"
import { useRouter } from "vue-router"

import Toolbar from "@/components/Toolbar.vue"
import CookieBanner from "@/components/CookieBanner.vue"
import { useSessionStore } from "@/stores/userSession.js"

const router = useRouter()
const sessionStore = useSessionStore()

const initialized = ref(false)
let refreshIntervalHandler = null

const refreshSession = async () => {
  if (!sessionStore.session) return
  try {
    await sessionStore.refreshToken()
  } catch {
    sessionStore.removeSession()
    router.push({ name: "login" })
  }
}

onMounted(async () => {
  refreshSession()
  refreshIntervalHandler = setInterval(refreshSession, 120000)
  await sessionStore.fetchDictionaries()
  initialized.value = true
})

onBeforeUnmount(() => {
  clearInterval(refreshIntervalHandler)
})
</script>
